import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {useGetCurrentUserQuery} from '../../redux/services/userApi';
// import AppDashboard from '../AppDashboard';

import {needsOnboarding} from '../../helpers/patients';
import LoadingScreen from '../../components/common/LoadingScreen';

const HomeRedirectPage = props => {
  const navigate = useNavigate();
  const userQuery = useGetCurrentUserQuery();
  const user = userQuery?.data?.data?.[0];
  useEffect(() => {
    if (userQuery.isFetching || userQuery.isLoading) {
      // do nothing!
    } else if (userQuery.error) {
      console.log('HomeRedirectPage redirecting from', window.location.href);
      navigate('/login');
    } else if (!user) {
      navigate('/exception');
    } else if (user?.is_patient && needsOnboarding(user?.patient)) {
      navigate('/clients/onboarding');
    } else if (user?.is_provider) {
      navigate('/providers');
    } else if (user?.is_patient) {
      navigate('/clients');
    } else {
      navigate('/exception');
    }
  }, [userQuery, user]);
  return <LoadingScreen />;
};

export default HomeRedirectPage;
